export default "__VITE_ASSET__DFATHJNZ__"